<div class="form-group"
     *ngIf="offsetSel">
  <select class="form-control"
          [(ngModel)]="offsetSel">
    <option *ngFor="let v of itensPorPag(); trackBy:tidn"
            [value]="v">{{ v }} itens
    </option>
  </select>
</div>
